import React, { useState, useEffect } from "react";
import { Button, Tooltip, CircularProgress, Switch } from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import { useLocation } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CustomModal from "../../components/CustomModel";
import FormInput from "../../components/GeneralComponents/FormInput";
import {
  Get_Account_Details,
  Scree_Base_List,
} from "../../DAL/Listing/AgencyAddAcount";
import { formatNumber, show_proper_words } from "../../utils/constant";
import {
  List_Account_WithDrawal_List,
  Update_Account_WithDrawal_Status,
} from "../../DAL/Listing/ActionsHistoy";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import moment from "moment";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";

const TopUpFunds = ({ dashboard }) => {
  const { setnavbarTitle, socket } = useAdminContext();
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [onFocusField, setOnFocusField] = useState(false);
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [rowDataID, setRowDataID] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [rowData, setRowData] = useState({});
  const [actionType, setActionType] = useState("");
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [modelState, setModelState] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [Data, setData] = useState({
    address: "",
    with_drawal_amount: "",
    tax_amount: "",
    over_all_amount: "",
  });
  const [employee, setEmployee] = useState(null);
  const [employeeArray, setEmployeeArray] = useState([]);
  const [loading, setLoading] = useState(true);

  /**
   * Fetches and formats employee details based on the search value.
   *
   * - Sends a request to fetch employee data using the provided search value.
   * - Formats the response by extracting user ID, name, and email, then updates the state.
   * - If the request fails (response code not 200), clears the employee data state.
   */
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "employee",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setEmployeeArray(FormatData);
    } else {
      setEmployeeArray([]);
    }
  };

  /**
   * Resets the state and closes the model.
   *
   * - Clears various state values including row data, data fields, action type, and employee details.
   * - Resets the model state and cancel flag to close the modal.
   */
  const handleCloseModel = () => {
    setRowDataID("");
    setData({
      address: "",
      with_drawal_amount: "",
      tax_amount: "",
      over_all_amount: "",
    });
    setActionType("");
    setEmployee(null);
    setRowData(null);
    setModelState(false);
    setIsCancel(false);
  };

  // This function handles page changes for pagination.
  // It updates the page state to the new page number and adjusts the page count accordingly.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function handles changes in the number of rows per page for pagination.
  // It updates the rowsPerPage state to the new value and resets the page state to 0.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles the page change for pagination.
  // If the new page is less than or equal to 0, it resets the page to 0 and sets the page count to 1.
  // Otherwise, it updates the page state to the new page and adjusts the page count accordingly.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  /**
   * Updates the status of a withdrawal request based on the action type (approve or reject).
   *
   * - Checks if the current status matches the action type and prevents updates if they're the same.
   * - Calculates the overall withdrawal amount after tax.
   * - Sends the withdrawal status update request to the server.
   * - Emits a socket event on success and resets relevant states, including employee info and data.
   * - Displays a snackbar message for success or failure.
   */
  const updateTopUpStatus = async (e) => {
    e.preventDefault();
    const isThatCancel =
      actionType === "approve"
        ? "approved"
        : actionType === "reject"
        ? "rejected"
        : "";

    if (rowData.status === isThatCancel) {
      enqueueSnackbar("This account already has this status", {
        variant: "warning",
      });
      return;
    }
    setData((prev) => {
      return {
        ...prev,
        over_all_amount: Data.with_drawal_amount - Data.tax_amount,
      };
    });

    const formData = {
      withdraw_amount: parseFloat(Data.with_drawal_amount),
      // tax_amount: parseFloat(Data?.tax_amount),
      // amount_after_tax: parseFloat(Data.with_drawal_amount - Data?.tax_amount),
      user_id: employee.id,
      message: Data.address,
      status:
        actionType === "approve"
          ? "approved"
          : actionType === "reject"
          ? "rejected"
          : "",
    };
    setLoadingButton(true);
    const response = await Update_Account_WithDrawal_Status(
      formData,
      rowDataID
    );
    if (response.code === 200) {
      socket.emit("clear_funds_event", {
        notification: response.notification,
      });
      setData({
        address: "",
      });
      setEmployee(null);
      GetAppealAccountList();
      handleCloseModel();
      setLoadingButton(false);
    } else {
      setLoadingButton(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * Fetches and sets the details of a specific account using the provided ID.
   *
   * - Retrieves account and withdrawal fund details.
   * - Sets the action type based on the current withdrawal fund status (approve/reject).
   * - Sets withdrawal amount and other account balance details.
   * - Updates the loading state and displays an error message if the request fails.
   */
  const GetAccountDetails = async (id) => {
    setDetailsLoading(true);
    const response = await Get_Account_Details(id);
    if (response.code === 200) {
      setActionType(
        response?.withdraw_fund?.status === "approved"
          ? "reject"
          : response?.withdraw_fund?.status === "rejected"
          ? "approve"
          : "approve"
      );
      setData({
        with_drawal_amount: Number(
          response?.account_balance?.account_balance
        ).toFixed(2),
      });
      setRowData({
        ...response?.withdraw_fund,
        ...response?.account_balance,
      });
      setDetailsLoading(false);
    } else {
      setDetailsLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              style={{
                fill: "#fff",
                marginRight: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                GetAccountDetails(row._id);
                // setRowData(row);
                setRowDataID(row._id);
                setModelState(true);
              }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "c",
      label: "Created At",
      renderData: (row) => (
        <div>{moment(row?.date_time).format("DD MMM YY hh:mm A")}</div>
      ),
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            GetAccountDetails(row._id);
            setRowDataID(row._id);
            setModelState(true);
          }}
        >
          <div>
            {show_proper_words(
              row?.user_info?.first_name + " " + row?.user_info?.last_name
            ) || "_ _"}
          </div>
          <div className="text-muted" style={{ fontSize: "0.9em" }}>
            {row?.user_info?.email || "_ _"}
          </div>
        </div>
      ),
    },
    {
      id: "accountName",
      label: "Account",
      renderData: (row) => (
        <div
          className="pointer"
          onClick={() => {
            GetAccountDetails(row._id);
            setRowDataID(row._id);
            setModelState(true);
          }}
        >
          <div>{row.account_name || "_ _"}</div> {/* Business Entity Above */}
          <div className="text-muted">{row?.email || "_ _"}</div>{" "}
          {/* Business Email Underneath */}
        </div>
      ),
    },
    {
      id: "amount",
      label: "Amount Withdrawn",
      renderData: (row) => (
        <div>
          {row?.withdraw_amount > 0
            ? "$" + formatNumber(row?.withdraw_amount)
            : "_" || "_ _"}
        </div>
      ),
    },
    // {
    //   id: "amount",
    //   label: "Ads Spend Fee",
    //   renderData: (row) => (
    //     <div>
    //       {row?.tax_amount > 0
    //         ? "$" + formatNumber(row?.tax_amount)
    //         : "_" || "_ _"}
    //     </div>
    //   ),
    // },
    // {
    //   id: "amount",
    //   label: "Amount Withdrawn",
    //   renderData: (row) => (
    //     <div>
    //       {row?.amount_after_tax > 0
    //         ? "$" + formatNumber(row?.amount_after_tax)
    //         : "_" || "_ _"}
    //     </div>
    //   ),
    // },
    {
      id: "type",
      label: "Account Type",
      renderData: (row) => (
        <span className=" capitalized">{row.type || "_ _"}</span>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip status={row.status} type="activeInactive" />
      ),
    },
  ];

  /**
   * Fetches and sets the list of appeal accounts (withdrawal requests).
   *
   * - Calls an API to fetch the list of withdrawal funds.
   * - Sets the retrieved list, total count, and total pages for pagination.
   * - Updates the loading state and displays an error message if the request fails.
   */
  const GetAppealAccountList = async () => {
    setLoading(true);
    const formData = {};
    const response = await List_Account_WithDrawal_List(
      formData,
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      const { list_withdraw_funds = [], total_count, total_pages } = response;
      setUserList(list_withdraw_funds);
      setTotalCount(total_count);
      setTotalPages(total_pages);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar("Failed to fetch data", { variant: "error" });
    }
  };

  const withdrawal = parseFloat(Data?.with_drawal_amount || 0).toFixed(2);
  const balance = parseFloat(rowData?.account_balance || 0).toFixed(2);

  useEffect(() => {
    if (!dashboard) {
      setnavbarTitle("Clear Account Funds");
    }
    GetAppealAccountList(page, rowsPerPage);
  }, [page, rowsPerPage, location.state?.refresh]);

  useEffect(() => {
    handleGetDetailUser();
  }, []);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="mt-3">
      <CustomTable
        data={userList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        pagePagination={true}
        handleChangePages={handleChangePages}
        is_hide={true}
      />
      <CustomModal
        crossButton={true}
        // CustomSpacing={true}
        open={modelState}
        handleClose={handleCloseModel}
        component={
          <>
            {detailsLoading ? (
              <div className="height_500 d-flex justify-content-center align-items-center">
                <CircularProgress />
              </div>
            ) : (
              <form onSubmit={updateTopUpStatus}>
                <div>
                  <h5>Funds Details</h5>
                  <div className="form-container pe-2">
                    {/* Basic Account Info */}
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-semibold">Created At</p>
                        <p className="mb-0 fw-semibold">Account</p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center text-muted">
                        <p className="mb-0">
                          {moment(rowData?.date_time).format(
                            "DD MMM YY hh:mm A"
                          )}
                        </p>
                        <p className="mb-0">{rowData?.business_entity}</p>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-semibold">Business Email</p>
                        <p className="mb-0 fw-semibold">
                          Total Available Balance
                        </p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center text-muted">
                        <p className="mb-0">{rowData?.email}</p>
                        <p className="mb-0">
                          ${formatNumber(rowData?.account_balance) || "0"}
                        </p>
                      </div>
                    </div>

                    {/* <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-semibold">Total Spending</p>
                        <p className="mb-0 fw-semibold">Ads Spend Fee</p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center text-muted">
                        <p className="mb-0">
                          ${formatNumber(rowData?.account_spendings) || "0"}
                        </p>
                        <p className="mb-0">
                          ${formatNumber(rowData?.tax_amount) || "0"}
                        </p>
                      </div>
                    </div> */}

                    <div className="mb-3">
                      {/* <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-semibold">Amount Withdrawn</p>
                      </div>
                      <div className="d-flex justify-content-between align-items-center text-muted">
                        <p className="mb-0">
                          ${formatNumber(rowData?.amount_after_tax) || "0"}
                        </p>
                      </div> */}
                    </div>

                    <hr />
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                      <h5>Action Type</h5>
                      <div className="d-flex align-items-center gap-2">
                        <span className="fw-semibold">
                          {actionType === "approve" ? "Approve" : "Reject"}
                        </span>
                        <Switch
                          checked={actionType === "reject"}
                          onChange={() =>
                            setActionType((prev) => {
                              if (prev === "approve") {
                                setIsCancel(false);
                                return "reject";
                              } else {
                                setIsCancel(true);
                                return "approve";
                              }
                            })
                          }
                          sx={{
                            "& .MuiSwitch-track": {
                              backgroundColor: "#d3d3d3", // light gray
                              opacity: 1, // ensure it's visible
                            },
                            "& .Mui-checked + .MuiSwitch-track": {
                              backgroundColor: "#d3d3d3", // keep it gray when checked
                            },
                          }}
                          color="primary"
                        />
                      </div>
                    </div>
                    {actionType !== "" && (
                      <>
                        {actionType === "approve" ? (
                          <>
                            <div className="row">
                              <div className="col-12 col-md-6 mt-2">
                                <SingleSelectAutocomplete
                                  inputLabel="Approve or Reject By"
                                  selectedOption={employee}
                                  setSelectedOption={setEmployee}
                                  optionsList={employeeArray}
                                  required={true}
                                  name="name"
                                  size="medium"
                                />
                              </div>
                              <div className="col-12 col-md-6">
                                <FormInput
                                  onBlur={() => setOnFocusField(false)}
                                  onFocus={() => setOnFocusField(true)}
                                  label="Enter Withdraw Amount $"
                                  name="with_drawal_amount"
                                  type="number"
                                  required={true}
                                  inputProps={{
                                    min: 1,
                                    max: Number(rowData?.account_balance) || 0,
                                    step: "0.01", // allow decimal values like 87.50
                                  }}
                                  value={Data.with_drawal_amount}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const numericValue = parseFloat(value);

                                    if (
                                      value === "" ||
                                      (!isNaN(numericValue) &&
                                        numericValue <=
                                          Number(rowData?.account_balance))
                                    ) {
                                      setData((prev) => ({
                                        ...prev,
                                        with_drawal_amount: value,
                                        tax_amount:
                                          Number(prev?.tax_amount) >
                                          Number(value)
                                            ? ""
                                            : prev?.tax_amount,
                                      }));
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {/* Withdrawal + Tax Form Section */}
                            {/* <div className="border rounded p-4 bg_lighter shadow-sm">
                              <div className="row">
                                <div className="col-12">
                                  <FormInput
                                    label="Enter Tax Amount $"
                                    name="tax_amount"
                                    type="number"
                                    inputProps={{
                                      min: 0,
                                      step: "0.01",
                                    }}
                                    required={true}
                                    value={Data?.tax_amount}
                                    onChange={(e) => {
                                      const taxValue = e.target.value;
                                      if (
                                        Number(taxValue) <=
                                        Number(Data.with_drawal_amount)
                                      ) {
                                        setData({
                                          ...Data,
                                          tax_amount: taxValue,
                                        });
                                      }
                                    }}
                                  />
                                </div>

                                Helper Text
                                {shouldShowHelper &&
                                  Number(Data.with_drawal_amount) > 0 &&
                                  Number(Data.with_drawal_amount) <
                                    Number(rowData?.account_balance) && (
                                    <div className="col-12">
                                      <div className="p-3 pt-0 text-danger small">
                                        The withdrawal amount is less than the
                                        available account balance.
                                        <br />
                                        Please add the remaining amount as a{" "}
                                        <span className="text-white">
                                          spending
                                        </span>{" "}
                                        to keep the balance sheet accurate.
                                        <br />
                                        <strong>
                                          Remaining: $
                                          {(
                                            Number(rowData?.account_balance) -
                                            Number(Data.with_drawal_amount || 0)
                                          ).toLocaleString()}
                                        </strong>
                                      </div>
                                    </div>
                                  )}

                                <div className="col-12 mb-3">
                                  <div
                                    className="p-3 bg-dark text-white rounded d-flex justify-content-between align-items-center"
                                    style={{
                                      fontSize: "1.1rem",
                                      fontWeight: "600",
                                    }}
                                  >
                                    <span>Total Amount to be Withdrawn</span>
                                    <span className="text-primary">
                                      $
                                      {Number(
                                        Data?.with_drawal_amount || 0
                                      ).toLocaleString()}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                          </>
                        ) : (
                          <>
                            <div className="mb-4">
                              <SingleSelectAutocomplete
                                inputLabel="Approve or Reject By"
                                selectedOption={employee}
                                setSelectedOption={setEmployee}
                                optionsList={employeeArray}
                                required={true}
                                name="name"
                                size="medium"
                              />
                            </div>
                            <div className="mt-1">
                              <FormInput
                                spacing={false}
                                label="Reject Message"
                                name="address"
                                type="text"
                                multline={true}
                                value={Data.address}
                                onChange={(e) =>
                                  setData({ ...Data, address: e.target.value })
                                }
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  {actionType !== "" && (
                    <div className="col-12 text-end mt-3">
                      {actionType === "reject" ? (
                        <Button
                          type="submit"
                          variant="contained"
                          disabled={!employee || loadingButton}
                          onClick={() => {
                            setIsCancel(true);
                          }}
                        >
                          Reject
                        </Button>
                      ) : (
                        <>
                          {/* Only show the Approve/Reject button when needed */}
                          {(rowData?.status !== "approved" || isCancel) && (
                            <Tooltip
                              title={
                                parseFloat(withdrawal) >= parseFloat(balance)
                                  ? "Withdrawal amount cannot exceed available balance"
                                  : ""
                              }
                              placement="top"
                              disableHoverListener={
                                Number(Data?.with_drawal_amount || 0) <=
                                Number(rowData?.account_balance)
                              }
                            >
                              <span>
                                <Button
                                  variant="contained"
                                  className="ms-3"
                                  disabled={!employee || loadingButton}
                                  type="submit"
                                >
                                  {loadingButton ? "Please Wait..." : "Approve"}
                                </Button>
                              </span>
                            </Tooltip>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </form>
            )}
          </>
        }
      />
    </div>
  );
};

export default TopUpFunds;
